import { useSelector } from 'react-redux';
import { Entity } from '../../models';
import { selectUPE } from '../../selectors';

export const useUPE = (): Entity | undefined => {
  const upe = useSelector(selectUPE);

  return upe;
};
